import { isEmpty } from 'ramda';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import { NamedQuery } from '@bridebook/toolbox/src/search-suppliers/types';
import { ICountry_Supplier } from '@bridebook/models/source/models/Countries.types';
import gazetteer from '@bridebook/toolbox/src/gazetteer';

export const supplierHasSpecialOffer = (supplier?: IUISupplier) => {
  if (!supplier) {
    return false;
  }
  const { latestSpecialOfferDate, bbDiscountExpiryDate } = supplier;
  return (
    (!!latestSpecialOfferDate && new Date(latestSpecialOfferDate) > new Date()) ||
    (!!bbDiscountExpiryDate && new Date(bbDiscountExpiryDate) > new Date())
  );
};

export const supplierHasWeddingFairOrOpenDay = (supplier?: IUISupplier) => {
  if (!supplier) return false;

  const { latestWeddingFairDate, latestOpenDayDate } = supplier;
  const now = new Date();

  return (
    (!!latestWeddingFairDate && new Date(latestWeddingFairDate) > now) ||
    (!!latestOpenDayDate && new Date(latestOpenDayDate) > now)
  );
};

export const isFirstNearbyResult = (list: IUISupplier[], listIndex: number): boolean =>
  isNearbyResult(list[listIndex]) && !isNearbyResult(list[listIndex - 1]);

export const isNearbyResult = (supplier: IUISupplier): boolean =>
  supplier?.matchedBy?.includes(NamedQuery.NearbyResult) || false;

export const supplierHasReviews = (supplier: IUISupplier) => {
  if (!supplier) {
    return false;
  }
  const { reviewsStars } = supplier;
  return Boolean(reviewsStars && reviewsStars !== -1);
};

export const supplierHasVideoTours = (supplier?: IUISupplier) => {
  if (!supplier) {
    return false;
  }

  const supplierCountry = supplier.l10n?.country;
  const supplierType = supplier.type;

  if (!supplierCountry || !supplierType) {
    return false;
  }

  const market = gazetteer.getMarketByCountry(supplierCountry);
  const minTierRequired = market.getSettingRequiredTier(
    'videoTours',
    supplierType as ICountry_Supplier,
  );

  const { videoToursCount = 0, tier = 0 } = supplier;

  return videoToursCount > 0 && tier >= minTierRequired;
};

export const supplierHasCovidUpdate = (supplier: IUISupplier) => {
  if (!supplier) {
    return false;
  }
  const { statusMessage } = supplier;

  return statusMessage && !isEmpty(statusMessage);
};

export const supplierHasQualityPricing = (supplier: IUISupplier) => {
  if (!supplier) {
    return false;
  }
  return supplier.hasQualityPricing;
};

export const supplierHasVideosUploaded = (supplier: IUISupplier, minVideos: number) => {
  if (!supplier) {
    return false;
  }

  return typeof supplier.videosCount === 'number' && supplier.videosCount >= minVideos;
};
